export * from './archiving-statuses-api-client.service';
import { ArchivingStatusesApiClient } from './archiving-statuses-api-client.service';
export * from './archiving-statuses-api-client.serviceInterface';
export * from './attachments-api-client.service';
import { AttachmentsApiClient } from './attachments-api-client.service';
export * from './attachments-api-client.serviceInterface';
export * from './business-premises-api-client.service';
import { BusinessPremisesApiClient } from './business-premises-api-client.service';
export * from './business-premises-api-client.serviceInterface';
export * from './cash-point-closings-api-client.service';
import { CashPointClosingsApiClient } from './cash-point-closings-api-client.service';
export * from './cash-point-closings-api-client.serviceInterface';
export * from './ers-api-client.service';
import { ErsApiClient } from './ers-api-client.service';
export * from './ers-api-client.serviceInterface';
export * from './imports-api-client.service';
import { ImportsApiClient } from './imports-api-client.service';
export * from './imports-api-client.serviceInterface';
export * from './keywords-api-client.service';
import { KeywordsApiClient } from './keywords-api-client.service';
export * from './keywords-api-client.serviceInterface';
export * from './open-archives-api-client.service';
import { OpenArchivesApiClient } from './open-archives-api-client.service';
export * from './open-archives-api-client.serviceInterface';
export * from './procedural-documentations-api-client.service';
import { ProceduralDocumentationsApiClient } from './procedural-documentations-api-client.service';
export * from './procedural-documentations-api-client.serviceInterface';
export * from './resources-api-client.service';
import { ResourcesApiClient } from './resources-api-client.service';
export * from './resources-api-client.serviceInterface';
export * from './tss-logs-api-client.service';
import { TssLogsApiClient } from './tss-logs-api-client.service';
export * from './tss-logs-api-client.serviceInterface';
export const APIS = [ArchivingStatusesApiClient, AttachmentsApiClient, BusinessPremisesApiClient, CashPointClosingsApiClient, ErsApiClient, ImportsApiClient, KeywordsApiClient, OpenArchivesApiClient, ProceduralDocumentationsApiClient, ResourcesApiClient, TssLogsApiClient];
